import { AlertType } from "../../../models/alert";
export class AttachmentManagerHelper {
    static errorHandler(error, appController, componentName, cRUDOperation) {
        if (error.status === 400 || error.status === 409 || error.status === 404) {
            let message = "";
            if (error.error)
                message = error.error;
            else if (error.error && error.error.value)
                message = error.error.value;
            appController.showMessage(error.error, AlertType.Error);
        }
        else
            appController.handleServerErrorMessage(componentName, error, cRUDOperation);
    }
    static createFormGroup(el, formBuilder) {
        return formBuilder.group({
            id: [el.id],
            attachmentType: [el.attachmentType],
            description: [el.description],
            uploadedByName: [el.uploadedBy],
            componentType: [el.componentType],
            moduleId: [el.moduleId],
            fileName: [el.fileName],
            uploadedById: [el.uploadedBy],
            fileSize: [el.fileSize],
            replacedBy: [el.replaceBy],
            revision: [el.revision],
            allowAccess: [el.allowAccess],
            file: [null],
        });
    }
}
